import React from 'react'
import { Breadcrumb, type BreadcrumbItem } from './Breadcrumb'

interface ContentHeaderProps {
  breadcrumb: BreadcrumbItem[]
  title: string
  subtitle?: string
  actions?: React.ReactNode
  filters?: React.ReactNode
}

export function ContentHeader({ breadcrumb, title, subtitle, actions, filters }: ContentHeaderProps) {
  return (
    <div className="mb-8">
      <Breadcrumb items={breadcrumb} />
      <div className="flex items-start justify-between gap-4 mt-4">
        <div>
          <h1 className="text-2xl font-bold text-[#1B2559]">{title}</h1>
          {subtitle && <p className="text-sm text-[#8B8FA7] mt-1">{subtitle}</p>}
        </div>
        {actions && <div className="flex items-center gap-3 shrink-0">{actions}</div>}
      </div>
      {filters && <div className="mt-4">{filters}</div>}
    </div>
  )
}
